<app-headline>
  <h1 app-headline-title color="primary">Animations</h1>
  <app-headline-actions>
    <button mat-icon-button
      (click)="openUploadForm()"
      matTooltip="Upload animations"
      aria-label="Upload animations">
      <mat-icon>file_upload</mat-icon>
    </button>
  </app-headline-actions>
</app-headline>

<ngrx-busy>
  @if (state$ | async; as state) {
    @if (state.error) {
      <p role="alert">Could not load animations. Reload the page to try again.</p>
    } @else {
      <div class="animations">
        @for (animation of state.animations; track animation.id) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>{{animation.name}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <app-animation-preview
                [imageUrl]="animation.image_url"
                [name]="animation.name"
                [fps]="animation.fps"
                [isPattern]="animation.is_pattern">
              </app-animation-preview>
              <div class="animation-key">
                <app-code appearance="text">{{animation.key}}</app-code>
              </div>
              <div class="metadata">
                <span>{{animation.fps}} FPS</span>
                <span>{{animation.is_pattern ? 'Pattern' : 'Animation'}}</span>
                @if (animation.preview_only) {
                  <span>Preview only</span>
                }
              </div>
            </mat-card-content>
          </mat-card>
        } @empty {
          <p>No animations available.</p>
        }
      </div>
    }
  }
</ngrx-busy>
